import HeroCarousel from '../components/HeroCarousel'
import StatsCounter from '../components/StatsCounter'
import AboutSection from '../components/AboutSection'
import TrendingGroups from '../components/TrendingGroups'
import { Link } from 'react-router-dom'
import { ArrowRight, Home, Car, Briefcase, Users, MessageSquare, Star } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

const HomePage = () => {
  const { user } = useAuth()
  const quickLinks = [
    {
      icon: <Home className="w-6 h-6" />,
      title: 'Encontrar Imóveis',
      description: 'Aluguel e venda de casas, apartamentos',
      color: 'from-blue-500/20 to-cyan-500/20',
      textColor: 'text-blue-400',
      path: '/listings?category=imoveis',
    },
    {
      icon: <Car className="w-6 h-6" />,
      title: 'Encontrar Carros',
      description: 'Veículos novos e usados',
      color: 'from-green-500/20 to-emerald-500/20',
      textColor: 'text-green-400',
      path: '/listings?category=veiculos',
    },
    {
      icon: <Briefcase className="w-6 h-6" />,
      title: 'Serviços',
      description: 'Profissionais e serviços gerais',
      color: 'from-purple-500/20 to-pink-500/20',
      textColor: 'text-purple-400',
      path: '/listings?category=servicos',
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: 'Grupos',
      description: 'Comunidades temáticas',
      color: 'from-amber-500/20 to-orange-500/20',
      textColor: 'text-amber-400',
      path: '/groups',
    },
    {
      icon: <MessageSquare className="w-6 h-6" />,
      title: 'Notícias',
      description: 'Atualizações e informações',
      color: 'from-red-500/20 to-rose-500/20',
      textColor: 'text-red-400',
      path: '/news',
    },
    {
      icon: <Star className="w-6 h-6" />,
      title: 'Destaques',
      description: 'Anúncios em destaque',
      color: 'from-indigo-500/20 to-violet-500/20',
      textColor: 'text-indigo-400',
      path: '/listings?featured=true',
    },
  ]

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section className="mb-8 md:mb-12">
        <HeroCarousel />
      </section>

      {/* Quick Links */}
      <section className="quick-links-section mb-8 md:mb-12">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
           <h2 className="text-3xl md:text-4xl font-bold text-noe-100 mb-10 text-center">
            Encontre o que você precisa <span className="text-noe-brand">rapidamente</span>
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
            {quickLinks.map((link, index) => (
              <Link
                key={index}
                to={link.path}
                className={`bg-gradient-to-br ${link.color} border border-noe-700/30 rounded-2xl p-5 text-center hover:scale-105 transition-all duration-300 hover:border-noe-brand/50 group`}
              >
                <div className={`p-3 rounded-full bg-noe-950/50 inline-flex items-center justify-center mb-4 ${link.textColor}`}>
                  {link.icon}
                </div>
                 <h3 className="font-bold text-noe-100 mb-2">{link.title}</h3>
                <p className="text-sm text-noe-300">{link.description}</p>
                <div className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArrowRight className={`w-4 h-4 ${link.textColor} inline`} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="mb-8 md:mb-12">
        <StatsCounter />
      </section>

      {/* About Section */}
      <section className="mb-8 md:mb-12">
        <AboutSection />
      </section>

      {/* Trending Groups */}
      <section className="mb-8 md:mb-12">
        <TrendingGroups />
      </section>

       {/* CTA Section - só para usuários não logados */}
       {!user && (
         <section className="mb-8 md:mb-12">
           <div className="max-w-7xl mx-auto px-6 md:px-12">
             <div className="bg-gradient-to-r from-noe-800/30 via-noe-900/30 to-noe-800/30 border border-noe-700/50 rounded-3xl p-8 md:p-12 text-center">
                <h2 className="text-3xl md:text-4xl font-bold text-noe-100 mb-6">
                 Pronto para fazer parte da <span className="text-noe-brand">maior comunidade</span> brasileira nos EUA?
               </h2>
               <p className="text-xl text-noe-300 mb-10 max-w-3xl mx-auto">
                 Junte-se a milhares de brasileiros que já estão conectados, informados e crescendo juntos.
               </p>
               <div className="flex flex-col sm:flex-row gap-4 justify-center">
                 <Link
                   to="/register"
                   className="px-8 py-4 bg-noe-brand text-noe-950 font-bold rounded-lg hover:bg-noe-brand/90 transition-colors text-lg"
                 >
                   Criar minha conta gratuita
                 </Link>
                 <Link
                   to="/about"
                   className="px-8 py-4 border border-noe-brand text-noe-brand font-bold rounded-lg hover:bg-noe-brand/10 transition-colors text-lg"
                 >
                   Saiba mais sobre nós
                 </Link>
               </div>
               <p className="text-noe-400 mt-8 text-sm">
                 Não precisa de visto para participar! Todos os brasileiros são bem-vindos.
               </p>
             </div>
           </div>
         </section>
       )}
    </div>
  )
}

export default HomePage